module.exports = __webpack_public_path__ + "media/audio1.3bf0b404.wav";